import * as ACTIONS from '../../Redux.constants';
import {Utilities} from '@learningblocks/exp-constants';

const {
  TOUR_PROPERTIES,
  setLocalStorageItem,
} = Utilities;

// Initial state for the TourReducer, which establishes the defaults
// for whether a tour is active (`tour`), which step of the tour is active (`stepIndex`), 
// and the data for the tour (`tourData`).
const INITIAL_STATE = {
  tour: false,
  stepIndex: 0,
  tourData: [],
}

/**
 * TourReducer is a reducer function to manage the state related to onboarding or guiding tours in the application.
 *
 * It manages several actions such as initializing tour data, starting the tour, 
 * incrementing tour steps, and ending the tour.
 *
 * @param {Object} state - The current state of the tour. Defaults to INITIAL_STATE.
 * @param {Object} action - The dispatched action.
 *
 * @returns {Object} - Returns the new state.
 */
export function TourReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // Sets the tour data from the GENERAL_CONFIG of the dispatched action payload.
    case ACTIONS.SET_LEVEL:
      return {
        ...state,
        tourData: action.payload.GENERAL_CONFIG.tourData
      }

    // Initiates the tour and resets the `stepIndex` to 0.
    case ACTIONS.START_TOUR:
      return {
        ...state,
        tour: true,
        stepIndex: 0
      };

    // Increments the `stepIndex` by 1 to move to the next step of the tour.
    case ACTIONS.INCREMENT_TOUR:
      return {
        ...state,
        stepIndex: state.stepIndex + 1
      }

    // Ends the tour and saves a flag in the local storage to indicate 
    // that the experimental design tour is finished.
    case ACTIONS.END_TOUR:
      setLocalStorageItem(TOUR_PROPERTIES.IS_EXPERIMENTAL_DESIGN_FINISHED, true);
      return {...state, tour: false}

    // For actions not related to this reducer, return the current state.
    default:
      return state;
  }
}
